import React, { Component, FunctionComponent, JSXElementConstructor, ReactElement, useState } from 'react';
import { useHistory } from 'react-router';
import { PrimaryButton } from '../connectedForm/Button';
import FluentModal from '../modals/FluentModal';

const ModalContentLink = ({
  content: FormContent,
  getFormUrl,
  embeddedView,
  onModalSelect,
  enabled,
  addButtonText,
  buttonComponent,
}: {
  content: JSXElementConstructor<any>;
  getFormUrl: () => string;
  embeddedView: boolean;
  onModalSelect: (data?: any) => void;
  enabled: boolean;
  addButtonText?: string;
  buttonComponent?: FunctionComponent<any>;
}) => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);

  const params = {
    id: 'New',
  };

  if (!enabled) return null;

  const ButtonComponent = buttonComponent ?? PrimaryButton;

  return (
    <>
      <ButtonComponent
        data-testid="wsAdd"
        onClick={() => {
          if (embeddedView) {
            setIsOpen(true);
          } else {
            history.push({
              pathname: `${getFormUrl()}New`,
              state: {
                previousLocation: history.location?.pathname || 'back',
              },
            });
          }
        }}
      >
        {addButtonText ?? 'Add'}
      </ButtonComponent>
      <FluentModal isOpen={isOpen} onDismiss={() => setIsOpen(false)}>
        <div style={{ height: '97vh', width: '90vw', position: 'relative' }}>
          <FormContent
            entityId={'Customer'}
            modalClose={true}
            onClose={() => setIsOpen(false)}
            onModalSelect={onModalSelect}
            match={{
              params: params, //Could be generally considered deprecated vs 'overrideParams' - Left in to ensure compatability.
            }}
            overrideParams={params}
          />
        </div>
      </FluentModal>
    </>
  );
};

export default ModalContentLink;
